import CustomButton from "@/components/elements/custom-button"

const WhitelistResult = ({data}) => {
    if (data) {
        const renderPrice = () => {
            if (data.price) {
                return (
                    <div className="ring-2 ring-white rounded-xl shadow-connectWallet flex items-center justify-center md:w-1/3 md:w-full px-4 md:px-8 py-2 md:py-3 mt-4 md:mt-0">
                        <span className="uppercase">{data.price}</span>
                    </div>
                )
            }
        }
        return (
            <div className="flex flex-col md:flex-row items-center justify-center space-y-4  md:space-y-0 space-x-5 text-xs md:text-xl text-primary whitespace-nowrap font-primary">
                {renderPrice()}
                <div className="ring-2 ring-white rounded-xl shadow-connectWallet flex flex-row items-center justify-between px-2 py-2 divide-x-[1px] divide-white">
                    <div className="flex flex-col items-center px-2 md:px-5">
                        <span>{data.totalWinner.title}</span>
                    </div>
                    <div className="flex flex-col items-center px-2 md:px-5">
                        <span>{data.totalWinner.value}</span>
                    </div>
                    <div className="hidden md:flex items-center px-2">
                        <a href={data.checkDetails.link} target={data.checkDetails.target}>
                            <CustomButton disable={false} label={data.checkDetails.title} />
                        </a>
                    </div>
                </div>
                <div className="md:hidden flex items-center px-2 md:px-3">
                    <a href={data.checkDetails.link} target={data.checkDetails.target}>
                        <CustomButton disable={false} label={data.checkDetails.title} />
                    </a>
                </div>
            </div>
        )
    }
    return null
}

export default WhitelistResult;
